<div class="container">
	<!-- Course Overview -->
	@if (courseSummary()) {
		<div class="divider" data-cy="clearing-course-overview">
			<div class="mb-4">
				<uc-heading
					headingTitle="Course Overview - {{ courseName() }}"
					[description]="courseSummary()"
				/>
			</div>
			@if (isFeatured() && externalUrl()) {
				<uc-clearing-visit-website-btn
					[externalUrl]="externalUrl()"
					[uniId]="uniId()"
					[uniName]="uniName()"
					[source]="courseName()"
					sourceType="course"
					customStyles="w-full sm:w-80"
					componentName="Course Overview"
					[cleSearchOrderPosition]="cleSearchOrderPosition()"
					[privacyPolicyUrl]="privacyPolicyUrl()"
				/>
			}
		</div>
	}
	@if (clearingUsp() && clearingCourseEnabled()) {
		<div class="divider" data-cy="clearing-course-usp">
			<div class="mb-4">
				<uc-heading
					headingTitle="Why Choose {{ uniName() }} During Clearing?"
					[description]="clearingUsp()"
				/>
			</div>
			@if (isFeatured() && externalUrl()) {
				<uc-clearing-visit-website-btn
					[externalUrl]="externalUrl()"
					componentName="Why Choose University"
					[uniId]="uniId()"
					[uniName]="uniName()"
					customStyles="w-full sm:w-80"
					[source]="courseName()"
					sourceType="course"
					[cleSearchOrderPosition]="cleSearchOrderPosition()"
					[privacyPolicyUrl]="privacyPolicyUrl()"
				/>
			}
		</div>
	}
</div>
